export enum ActionDialogType {
  // Information will display a message and 1 button to close the dialog
  Information,
  // Confirmation will display a button to confirm the action (with default button color) or cancel the action
  Confirmation,
  // Delete Confirmation will display a button to confirm the deletion (with red button color) or cancel the action
  DeleteConfirmation,
}
